import { appConfig } from "../../app-config.ts"

export const Terms = () => {
  return (
    <span className="text-xs text-gray-11 mt-4">
      By joining, you agree to IYK&apos;s{" "}
      <a href={appConfig.assets.documents.privacyPolicy} target="_blank" className="underline">
        Privacy Policy
      </a>
      {" & "}
      <a href={appConfig.assets.documents.termsOfService} target="_blank" className="underline">
        Terms of Service
      </a>
    </span>
  )
}
